import React from 'react';
import M365EmailConfig from '../components/Configuracion/M365EmailConfig';
import EmailConfig from '../components/Configuracion/EmailConfig';

const ConfiguracionEmail = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <EmailConfig />
      <M365EmailConfig />
    </div>
  );
};

export default ConfiguracionEmail;
